<template>
  <v-container class="container">
    <div v-if="!show" class="column">
      <v-flex>
        <div>
          <v-layout>
            <v-flex xs12 sm10 offset-sm1>
              <v-text-field style="padding: 10px"
                  v-model="search"
                  @keyup="searchFilter"
                  append-icon="search"
                  label="Buscar"
                  single-line
                  hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <div style="overflow-y: scroll; overflow-x: hidden;  height:85vh; " >
        <template>
          <v-treeview
              open-all
              :items="items"
          >
            <template v-slot:prepend="{ item }" >
              <div style="width: 5%;">
              </div>
              <div @click="searchData(item.id);" class="flex-container">
                <img v-if="item.authority=='ROLE_ADMIN'" src="../../../assets/logo.png" width="30px">
                <img v-if="item.authority=='ROLE_USER'" :src="(item.gender=='Femenino') ? 'https://imagenes-tugps.s3.amazonaws.com/female1.png' : 'https://imagenes-tugps.s3.amazonaws.com/male1.png'" width="30px">
                <img v-if="item.authority=='ROLE_FLOTA'" :src="(item.gender=='Femenino') ? 'https://avatars-tupgps.s3.amazonaws.com/personas/femaleFlota.png' : 'https://avatars-tupgps.s3.amazonaws.com/personas/maleFlota.png'" width="30px">
                <img v-if="item.authority=='ROLE_INSTALADOR'" src="https://imagenes-tugps.s3.amazonaws.com/INSTALADOR.png" width="30px">
                <img v-if="item.authority=='ROLE_CHOFER'" src="https://imagenes-tugps.s3.amazonaws.com/CHOFER.png" width="30px">
                <a class="text-tree-view">{{ item.name }}</a>
              </div>
            </template>
          </v-treeview>
        </template>
      </div>
    </div>
    <div v-if="show" class="column" style="padding: 5px">
      <v-btn class="btn-rounded" @click="show = false; clearIntervalVue(false)" large color="primary">Regresar</v-btn>
      <div v-if="devices!=null && devices.length>0">
        <v-flex>
          <div>
            <v-layout>
              <v-flex xs12 sm10 offset-sm1>
                <v-text-field
                    v-model="search2"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <div style="overflow-y: scroll; height:80vh;">
          <v-data-table
              :headers="headers2"
              :items="devices"
              :search="search2"
              class="elevation-1"
              sort-icon="mdi-menu-down"
              hide-actions
          >
            <template slot="items" slot-scope="props">
              <td
              class="text-xs-left"
              style="padding-inline: 2px !important;"
              @click="$store.getters.isActiveDevice(props.item) && selectedItem(props.item, true)"
            >
              <img :src="props.item.image" width="40px" style="display: block; margin: auto;">
            </td>
            <td
              class="text-xs-left"
              style="padding-inline: 2px !important;"
              @click="$store.getters.isActiveDevice(props.item) && selectedItem(props.item, true)"
            >
              <span>
                {{ props.item.name.toUpperCase() }}
                <span v-if="!$store.getters.isActiveDevice(props.item)"> / Inactivo</span>
              </span>
            </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              No se han encontrado resultados para "{{ search }}".
            </v-alert>
          </v-data-table>
          <div align="center">
            <br>
            <v-btn v-if="devices.length>1" color="primary" @click="dialogMapMultiple=true">Ver mapa</v-btn>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-if="dialogInfo==true"
              v-model="dialogInfo"
              persistent
              fullscreen
              transition="dialog-bottom-transition"
              scrollable>

      <v-card tile>
        <div class="backgroundStreet">
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialogInfo = false; clearIntervalVue(false); cleanData()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Información Dispositivo</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text style="padding: 0 !important;">
            <v-form ref="form" v-model="valid" lazy-validation>
              <div style="background-color: #f3aa32; max-height: 50%; max-height: 50%">
                <span style="position: absolute; font-size: 14px; font-weight: bold">Actualización en: {{ this.expires_in }}</span>
                <br>
                <div align="center">
                  <div class="styleDeviceName">
                    <h3 style="color: #f3aa32">{{ this.device.name.toUpperCase() }}</h3><br>
                  </div>
                </div>
                <br>
                <div align="center">
                  <div v-if="(!this.device.offline && this.device.status === 'rely')  || (!this.device.offline && this.device.accStatus == '1' && this.device.speed == '0')" class="styleDeviceStatus2">
                    <div align="center">
                      <span class="styleDeviceSpeed">0</span>
                      <br>
                      <span style="font-weight: bold;">KM/H</span><br>
                      <span style="color: #ffd500; font-weight: bold;font-size: 14px">DETENIDO </span><br>
                      <span style="color: #ffd500; font-weight: bold;font-size: 14px">PRENDIDO</span>
                      <div style="font-weight: bold;">{{this.$store.getters.msToTime(this.device.timeRely)}}</div>
                    </div>
                  </div>
                  <div v-else-if="!this.device.offline && this.device.accStatus == '1' && parseInt(this.device.speed) > 0" class="styleDeviceStatus">
                    <div align="center">
                      <span class="styleDeviceSpeed">{{ this.device.accStatus == '1' ? (this.device.speed*1.852).toFixed(0) : '0' }}</span>
                      <br>
                      <span style="font-weight: bold;">KM/H</span><br>
                      <span style="color: greenyellow; font-weight: bold; font-size: 14px ">MOVIMIENTO</span>
                    </div>
                  </div>
                  <div v-else-if="!this.device.offline && this.device.accStatus == '0'" class="styleDeviceStatus">
                    <div align="center">
                      <span class="styleDeviceSpeed">{{ this.device.accStatus == '1' ? this.device.speed.toFixed(2) : '0' }}</span>
                      <br>
                      <span style="font-weight: bold;">KM/H</span><br>
                      <span style="color: red; font-weight: bold;font-size: 14px">DETENIDO</span>
                      <div style="font-weight: bold;">{{this.$store.getters.msToTime(this.device.timeStop)}}</div>
                    </div>
                  </div>
                  <div v-else-if="this.device.offline" class="styleDeviceStatus">
                    <div align="center">
                      <span class="styleDeviceSpeed">0</span>
                      <br>
                      <span style="color: gray; font-weight: bold;font-size: 14px">FUERA DE LINEA</span>
                      <span>{{this.$store.getters.msToTime(this.device.timeOffline)}}</span>
                    </div>
                  </div>

                  <div align="center">
                    <img :src="this.device.icon.url2" width="20%">
                  </div>
                  <div v-if="!this.device.offline">
                    <img src="https://icons.iconarchive.com/icons/icons8/android/512/Transport-Engine-icon.png" alt=""
                         style="width: 25px">
                    <span style="font-size: 14px">{{
                        this.device.accStatus == '1' ? 'ENCENDIDO' : 'APAGADO'
                      }}</span>
                      <br>
                  </div>
                </div>
                <br>
                <br>
                <div style="padding-left: 15px">
                  <v-layout>
                    <v-flex xs12 sm10 offset-sm1>
                      <div>
                        <span style="color: black; font-weight: bold; font-size: 14px">POSICIÓN: </span><span
                          style="font-size: 14px"><a
                          :href="'https://maps.google.com/?q='+this.device.position.lat+','+this.device.position.lng"
                          target="_blank"
                          style="color: black; font-size: 14px">{{
                          this.device.position.lat.toFixed(4)
                        }},{{ this.device.position.lng.toFixed(4) }}</a></span>
                        <br>
                        <!-- <span style="color: black; font-weight: bold; font-size: 14px">DIRECCIÓN: </span><span
                          style="font-size: 14px">{{ this.direction }}</span>
                        <br> -->
                        <strong>Odómetro: </strong>{{parseInt(this.device.odometer)}} Km<br>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
              <div align="center">
                <br>
                <table width="100%">
                  <tr>
                    <td>
                      <div align="center" v-if="!$store.getters.isChofer">
                        <v-btn
                            fab
                            class="circleButton"
                            @click="dialogBlock=true">
                          <v-icon v-if="this.device.blocked" dark>lock_open</v-icon>
                          <v-icon v-if="!this.device.blocked" dark>lock</v-icon>
                        </v-btn>
                        <br>
                        <span v-if="this.device.blocked" style="font-size: 12px">Desbloqueo</span>
                        <span v-if="!this.device.blocked" style="font-size: 12px">Bloqueo</span>
                      </div>
                    </td>
                    <td>
                      <div align="center">
                        <v-btn
                            fab
                            class="circleButton"
                            @click="dialogMap=true">
                          <v-icon dark>map</v-icon>
                        </v-btn>
                        <br>
                        <span style="font-size: 12px">Mapa</span>
                      </div>
                    </td>
                    <td>
                      <div align="center">
                        <v-btn
                            fab
                            class="circleButton"
                            @click="dialogReport=true, searched=false, clearIntervalVue(false)">
                          <v-icon dark>moving</v-icon>
                        </v-btn>
                        <br>
                        <span style="font-size: 12px">Recorrido</span>
                      </div>
                    </td>

                  </tr>
                  <tr>
                    <td>
                      <div align="center">
                        <v-btn
                            fab
                            class="circleButton"
                            @click="dialogAlert=true">
                          <v-icon dark>notification_important</v-icon>
                        </v-btn>
                        <br>
                        <span style="font-size: 12px">Alertas</span>
                      </div>
                    </td>
                    <td>
                      <div align="center">
                        <v-btn fab
                                class="circleButton">
                            <a :href="encodeURI(toGoogleMapsLink)" target="_blank"><v-icon dark>filter_center_focus</v-icon></a>
                        </v-btn>
                        <br>
                        <span style="font-size: 12px">Cómo llegar</span>
                      </div>
                    </td>
                    <td>
                      <div align="center">
                        <v-btn fab
                               class="circleButton" target="_blank">
                          <a :href="encodeURI('https://wa.me/?text='+waMessage)" target="_blank"><v-icon dark>share</v-icon></a>
                        </v-btn>
                        <br>
                        <span style="font-size: 12px">Compartir</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogBlock"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
      <v-card tile>
        <v-toolbar card dark color="nav_background_color">
          <v-btn icon dark @click.native="dialogBlock = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Acción en dispositivo</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
              <h3>Al presionar el botón ejecutarás el comando.</h3>
            </v-layout>
            <v-layout>
              <v-flex class="text-xs-center">
                <div>
                  <v-btn  :disabled="!valid"
                  @click="sendDeviceActionBlock()" small color="primary">Bloquear
                  </v-btn>
                  <v-btn  :disabled="!valid"
                         @click="sendDeviceActionUnBlock()" small color="primary">Desbloquear
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogMap==true" v-model="this.dialogMap"
              persistent
              fullscreen
              transition="dialog-bottom-transition">
      <v-toolbar fixed card dark color="nav_background_color" dense>
        <v-btn icon dark @click.native="dialogMap = false;clearIntervalVue(true);">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Mapa</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card tile style="padding: 0%">
        <v-card-text style="padding: 0%">
          <map-mobile :devices="this.devices" :device="this.device"></map-mobile>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogMapMultiple==true" v-model="this.dialogMapMultiple"
              persistent
              fullscreen
              transition="dialog-bottom-transition">
      <v-toolbar fixed card dark color="nav_background_color" dense>
        <v-btn icon dark @click.native="dialogMapMultiple = false; clearIntervalVue(false); cleanData()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Mapa</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card tile style="padding: 0%">
        <v-card-text style="padding: 0%">
          <map-mobile-multiple :devices="this.devices" :device="this.device" @close-dialog="closeDialogMapMultiple"></map-mobile-multiple>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogReport==true" v-model="this.dialogReport"
              fullscreen>
      <v-toolbar fixed card dark color="nav_background_color" dense>
        <v-btn icon dark @click.native="dialogReport = false;clearIntervalVue(true)">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Recorrido</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card tile style="padding: 0%">
        <v-card-text style="padding: 0%">
          <div class="backgroundStreet">
          <report-mobile :devices="this.devices" :device="this.device"></report-mobile>
        </div>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <v-dialog v-if="dialogDirection==true" v-model="this.dialogDirection"
              fullscreen>
      <v-toolbar fixed card dark color="nav_background_color" dense>
        <v-btn icon dark @click.native="dialogDirection = false;">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Cómo llegar</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card tile style="padding: 0%">
        <v-card-text style="padding: 0%">
          <direction-mobile :devices="this.devices" :device="this.device"></direction-mobile>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogAlert==true" v-model="this.dialogAlert"
              fullscreen>
      <v-toolbar fixed card dark color="nav_background_color" dense>
        <v-btn icon dark @click.native="dialogAlert = false;">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Alertas</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card tile style="padding: 0%">
        <v-card-text style="padding: 0%">
          <alert-mobile :devices="this.devices" :device="this.device"></alert-mobile>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogError"
        max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span>No se ha podido obtener la geolocalización del dispositivo</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
              color="primary"
              text
              @click="dialogError = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogNotification"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
      <v-card tile>
        <v-toolbar card dark color="nav_background_color" dense>
          <v-btn icon dark @click.native="dialogNotification = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Acción en dispositivo</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
              <span>Dispositivo: {{ this.device.notificationDataDeviceName }}.</span>
            </v-layout>
            <v-layout>
              <span>Estado: {{ this.device.notificationBody }}.</span>
            </v-layout>
            <v-layout>
              <v-flex class="text-xs-center">
                <div>
                  <v-btn
                    color="primary"
                    text
                    @click="dialogNotification = false">
                    Cerrar
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Device from '../../../model/Device';
import VueTimepicker from 'vue2-timepicker/src'
import MapMobile from "./MapMobile";
import MapMobileMultiple from "./MapMobileMultiple";
import ReportMobile from "./ReportMobile";
import DirectionMobile from "./DirectionMobile";
import AlertMobile from "./AlertMobile";
import { Capacitor } from '@capacitor/core';
import {
  PushNotifications,
} from '@capacitor/push-notifications';
import {
  LocalNotifications,
} from '@capacitor/local-notifications';

export default {
  components: {
    VueTimepicker,
    MapMobile,
    MapMobileMultiple,
    ReportMobile,
    DirectionMobile,
    AlertMobile
  },
  data() {
 
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      dialogInfo: false,
      markers: [],
      editedIndex: -1,
      device: new Device(),
      date: "",
      menu: false,
      menu2: false,
      deviceObject: {id: "", value: "", date: new Date()},
      singleSelect: false,
      active: 0,
      dialogBlock: false,
      dialogError: false,
      dialogGeo: false,
      devices: [],
      infoOpened: false,
      infoOptions: null,
      infoPosition: null,
      infoContent: null,
      marker: null,
      headers2: [
        {text: 'Avatar', value: 'avatar' , width:'10%'},
        {text: 'Dispositivo', value: 'name',width:'45%'},
      ],
      mapView: {lat: -0.190029, lng: -78.482114},
      expires_in: 0,
      selectedInMap: "",
      dialogMap: false,
      dialogMapMultiple: false,
      dialogReport: false,
      dialogAlert: false,
      dialogDirection: false,
      searched: false,
      reportType: '',
      interval: 0,
      path: [],
      reportData: [],
      increment: 1,
      listReportTracking: [],
      colorLine: '#008000',
      typesReport: ["RUTA", "KILOMETROS"],
      direction: "",
      waMessage: "",
      toGoogleMapsLink: "",
      dialogNotification: false,
      items: [],
      items2: [
        {
          id: 1,
          name: 'Applications :',
          children: [
            { id: 2, name: 'Calendar : app' },
            { id: 3, name: 'Chrome : app' },
            { id: 4, name: 'Webstorm : app' },
          ],
        },
        {
          id: 5,
          name: 'Documents :',
          children: [
            {
              id: 6,
              name: 'vuetify :',
              children: [
                {
                  id: 7,
                  name: 'src :',
                  children: [
                    { id: 8, name: 'index : ts' },
                    { id: 9, name: 'bootstrap : ts' },
                  ],
                },
              ],
            },
            {
              id: 10,
              name: 'material2 :',
              children: [
                {
                  id: 11,
                  name: 'src :',
                  children: [
                    { id: 12, name: 'v-btn : ts' },
                    { id: 13, name: 'v-card : ts' },
                    { id: 14, name: 'v-window : ts' },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 15,
          name: 'Downloads :',
          children: [
            { id: 16, name: 'October : pdf' },
            { id: 17, name: 'November : pdf' },
            { id: 18, name: 'Tutorial : html' },
          ],
        },
        {
          id: 19,
          name: 'Videos :',
          children: [
            {
              id: 20,
              name: 'Tutorials :',
              children: [
                { id: 21, name: 'Basic layouts : mp4' },
                { id: 22, name: 'Advanced techniques : mp4' },
                { id: 23, name: 'All about app : dir' },
              ],
            },
            { id: 24, name: 'Intro : mov' },
            { id: 25, name: 'Conference introduction : avi' },
          ],
        },
      ],
      itemsOriginal: [],
      search2: '',
      show: false,
    };
  },
  watch: {},
  methods: {
    closeDialogMapMultiple(updatedDevice) {
      this.device = updatedDevice;
      this.selectedItem(this.device, false)
    },
    cleanData() {
      //this.$refs.form.reset();
      this.device = new Device();
      this.valid = false;
      this.dialog = false;
    },

    editItem(item) {
      this.editedIndex = this.devices.indexOf(item);
      this.device = Object.assign({}, item);
      this.dialog = true;
    },
    createInterval() {
      clearInterval(this.$store.state.intervalMap)
      const self = this;
      this.$store.state.intervalMap = setInterval(() => {
        if (self.expires_in === 0) {

          self.expires_in = 10
          self.$store.dispatch('getDevicesLocationTraccar', self.device.idTraccar).then(response => {
            // this.$store.dispatch('getStreetFromCoordinates', {
            //   lat: response.data.result[0].lat,
            //   lng: response.data.result[0].lng,
            //   imei: this.devices[this.editedIndex].imei
            // }).then(response1 => {
            //   this.direction = response1
            // })
            self.markers = []
            if (response.data.result.length == 0) {
              self.dialogError = true
            } else {
              self.device.accStatus = response.data.result[0].accStatus,
                  self.device.speed = response.data.result[0].speed,
                  self.device.blocked = self.devices[self.editedIndex].lastAction == 'Bloqueado' ? true : false
              self.device.position = {
                lat: response.data.result[0].lat,
                lng: response.data.result[0].lng,
                imei: self.device.imei
              }
              if (response.data.result[0].status === "rely" || (this.accStatus == '1' && motion == '0')) {
                  let queryParam = "deviceId=" + this.devices[this.editedIndex].idTraccar
                  this.$store.dispatch('getDevicesLocationTraccarLastRely', queryParam).then(responseReport => {
                    if (responseReport == null || responseReport === undefined || responseReport.data == null) {
                      return 0
                    }
                    let now = new Date();
                    let lastTime = responseReport.data.result[0]
                    let gpsTime = new Date(lastTime.deviceTime);
                    //console.log(gpsTime)
                    let timeDifferenceRely = now - gpsTime;
                    //console.log(timeDifferenceRely)
                    let minutesRely = timeDifferenceRely / 1000 / 60;
                    //console.log('Time Difference Rely (minutes):', minutesRely);
                    self.device.timeRely = timeDifferenceRely
                  });
                }
            }
          })
        } else {
          this.expires_in = this.expires_in - 1;
        }
      }, 1000);
    },

    selectedItem(item, fromList) {
      this.$store.state.progress = true;
      if(fromList === true){
        this.singleSelect = false
        this.editedIndex = this.devices.indexOf(item);
      }else{
        this.editedIndex = this.devices.findIndex(device => device.imei === item.imei);
      }
      this.device = this.devices[this.editedIndex]
      try{
      this.$store.dispatch('getDevicesLocationTraccar', this.device.idTraccar).then(response => {
        if (response.data == null || typeof response.data.result === 'undefined' || response.data.result.length == 0) {
          this.dialogError = true
        } else {
          // Set coordinates from device latest position
          this.lat = response.data.result[0].lat;
          this.lng = response.data.result[0].lng;
          // this.$store.dispatch('getStreetFromCoordinates', {
          //   lat: this.lat,
          //   lng: this.lng,
          //   imei: this.device.imei
          // }).then(response1 => {
            this.toGoogleMapsLink = 'https://maps.google.com/?q=' + response.data.result[0].lat + ',' + response.data.result[0].lng + '';
          //   this.direction = response1
            this.waMessage = 'Nombre dispositivo: ' + this.device.name +
                '. Estado dispositivo: ' + (this.device.accStatus == '0' ? 'APAGADO' : 'PRENDIDO') +
                // '. Dirección: ' + this.direction +
                '. Posición actual: ' + 'https://maps.google.com/?q=' + response.data.result[0].lat + ',' + response.data.result[0].lng;

            let queryParam = "deviceId="+this.devices[this.editedIndex].idTraccar+"&from="+this.dateStart()+"&"+"to="+this.dateEnd()

            // Get the latest events
            this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(responseEvent => {
              let image = this.devices[this.editedIndex].image
              let motion = response.data.result[0].motion;
              this.accStatus = response.data.result[0].accStatus;
              if (response.data.result[0].status === 'rely' || (this.accStatus == '1' && motion == '0')) {
              image = image.replace("1.", "A.");
            } else if (this.accStatus == '1' && parseInt(response.data.result[0].speed) > 0) {
              image = image.replace("1.", "V.");
            } else if (this.accStatus == '0') {
              image = image.replace("1.", "R.");
            } else {
              image = image.replace("1.", "G.");
            }

  
            let now = new Date();
            let deviceTime = new Date(response.data.result[0].deviceTime);
            let minutesForOffline = 7 * 60 * 1000; // 10 minutes
            // If the latest position device time is grater than minutesForOffline then
            // assing time between deviceTime and now to timeStop
            let timeStop = {}
            let offline = false
            let timeDifference = now - deviceTime;

            let timeOffline = timeDifference;
            let minutesOffline = timeDifference / 1000 / 60;
            //************************IMPORTANT TO TRACE******************************
            //console.log('Time Difference (minutes):', minutesOffline);
              // If the latest position device time is grater than minutesForOffline then
              // assing time between deviceTime and now to timeStop
              if (timeDifference > minutesForOffline) {
                image = image.replace("1.", "G.");
                image = image.replace("V.", "G.");
                image = image.replace("R.", "G.");
                image = image.replace("A.", "G.");
                timeStop = (deviceTime.getTime() - (now.getTime())) * -1;
                offline = true;
              } else {
                offline = false;
              }

              // If device is stopped then get timeStop from event response when type is ignitionOff
              if (!this.offline && this.accStatus == '0') {
                for (let i = 0; i < responseEvent.data.length; i++) {
                  if (responseEvent.data[i].type == "ignitionOff") {
                    deviceTime = new Date(responseEvent.data[i].eventTime);
                    timeStop = (now.getTime() - deviceTime.getTime());
                    break;
                  }
                }
              }

              let respPosition = {
                  position: {
                    lat: this.lat,
                    lng: this.lng,
                    imei: this.devices[this.editedIndex].imei
                  },
                  icon: {
                    url2: this.devices[this.editedIndex].image,
                    url: image,
                    scaledSize: { width: 40, height: 40, f: 'px', b: 'px' }
                  },
                  imei: this.devices[this.editedIndex].imei,
                  name: this.devices[this.editedIndex].name,
                  sim: this.devices[this.editedIndex].sim,
                  model: this.devices[this.editedIndex].model,
                  accStatus: this.accStatus,
                  speed: response.data.result[0].speed,
                  blocked: this.offline,
                }
                this.mapView = {
                  lat: response.data.result[0].lat,
                  lng: response.data.result[0].lng,
                },
                  this.markers.push(respPosition)
                this.devices[this.editedIndex].selected = true
                this.device = this.devices[this.editedIndex]
                if (response.data.result[0].status === "rely" || (this.accStatus == '1' && motion == '0')) {
                  let queryParam = "deviceId=" + this.devices[this.editedIndex].idTraccar
                  this.$store.dispatch('getDevicesLocationTraccarLastRely', queryParam).then(responseReport => {
                    if (responseReport == null || responseReport === undefined || responseReport.data == null) {
                      return 0
                    }
                    let lastTime = responseReport.data.result[0]
                    let gpsTime = new Date(lastTime.deviceTime);
                    //console.log(gpsTime)
                    let timeDifferenceRely = now - gpsTime;
                    //console.log(timeDifferenceRely)
                    let minutesRely = timeDifferenceRely / 1000 / 60;
                    //console.log('Time Difference Rely (minutes):', minutesRely);
                    this.device.timeRely = timeDifferenceRely
                  });
                }
                this.device.accStatus = this.accStatus,
                  this.device.speed = response.data.result[0].speed,
                  this.device.blocked = this.devices[this.editedIndex].lastAction == 'Bloqueado' ? true : false
                this.device.odometer = response.data.result[0].odometer,
                  this.device.offline = offline
                this.device.timeStop = timeStop
                this.device.timeOffline = timeOffline
                this.device.status = response.data.result[0].status
                this.device.position = {
                  lat: this.lat,
                  lng: this.lng,
                  imei: this.device.imei
                },
                  this.device.icon = {
                    url2: this.devices[this.editedIndex].image,
                    url: this.device.image,
                    size: { width: 70, height: 80, f: 'px', b: 'px' },
                    scaledSize: { width: 60, height: 60, f: 'px', b: 'px' }
                  },
              this.createInterval()
              this.dialogInfo = true
              this.dialogMapMultiple = false
              this.$store.state.progress = false;
              
            })
        }
      }).catch((error)=>{
        this.dialogError = true
        console.log("No hay datos de dispositivos")
          })
      }catch (e){
        this.dialogError = true
        console.log("No hay datos de dispositivos")
      }
    },

    searchData(login) {
      //This is for SUPER USERS IN A COMPANY
      if(login === 'grupooro357'){
        return;
      }
      this.$store.dispatch('getRelatedDevicesByUserLogin', login).then(response => {
        this.devices = []
        this.geoFences = []
        this.markers = []
        for (let i = 0; i < response.data.length; i++) {
          let object = JSON.parse(response.data[i].value)
          object.id = response.data[i].id
          object.selected = false
          object.user = response.data[i].user
          this.devices.push(object)
        }
        if(this.level == 0){
          this.level = 1
        }
        this.devices.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
        this.$store.dispatch('getOneUser', login).then(responseData => {
          if(responseData.data.clientData!=null){
            let clientData= JSON.parse(responseData.data.clientData)
            if(clientData.devices.length>0){
              for (const clientDatum of clientData.devices) {
                if(clientDatum!=null) {
                  this.devices.push(clientDatum)
                }
              }
            }
          }
        });
        this.show = true
        
      })
    },

    sendDeviceActionBlock() {
        this.$store.dispatch('sendDeviceActionTraccar', {
          "deviceId": this.device.idTraccar,
          "description": "version",
          "type": "custom",
          "attributes": {
            "data": "Relay,1#"
          }
        }).then(response => {
          this.device.lastAction = 'Bloqueado'
          this.device.blocked = true
          this.devices[this.editedIndex].lastAction = 'Bloqueado'
          this.saveData(true)
          this.dialogBlock = false
        })
    },
    sendDeviceActionUnBlock() {
      this.$store.dispatch('sendDeviceActionTraccar', {
              "deviceId": this.device.idTraccar,
              "description": "version",
              "type": "custom",
              "attributes": {
                "data": "Relay,0#"
              }
            }
        ).then(response => {
          this.device.lastAction = 'Desbloqueado'
          this.device.blocked = false
          this.devices[this.editedIndex].lastAction = 'Desbloqueado'
          this.saveData(true)
          this.dialogBlock = false
        })
    },

    saveData(reload) {
      this.$store.dispatch('getOneUser', this.device.user.login).then(
          responseUser => {
            if(this.$store.state.deviceUser.firstName!=null){
              this.device.userName = this.$store.state.deviceUser.firstName + " "+this.$store.state.deviceUser.lastName
            }
            this.deviceObject.value = JSON.stringify(this.device)
            this.deviceObject.id = this.device.id
            this.deviceObject.user = responseUser.data
            let deviceValue = JSON.parse(this.deviceObject.value);
            this.deviceObject.idTraccar = deviceValue.idTraccar;

            if (this.device.id != null && this.device.id != "") {
              this.$store.dispatch('updateDevice', this.deviceObject).then(
                  response => {
                    if(reload){
                      this.reload();
                    }
                  },
                  error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                  }
              );
            } else {
              this.deviceObject.date = new Date()
              this.deviceObject.user = responseUser.data
              this.deviceObject.user.clientData = ""
              this.$store.dispatch('addDevice', this.deviceObject).then(
                  response => {
                    if(reload){
                      this.reload();
                    }
                  },
                  error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                  }
              );
            }
            this.dialog = false;
          },
          error => {
            this.$store.state.progress = false;
            this.$store.state.dialogError = true;
          }
      );
    },

    searchFilter(){
      let result = this.itemsOriginal
      this.items=result
      if (!this.search || this.search=='')
        return result

      const filterValue = this.search.toLowerCase()

      const filter = event =>
          event.name.toLowerCase().includes(filterValue)

      return this.items=result.filter(filter)
    },

    openBlockDialog() {
      this.dialogBlock = true
    },

    formatDate(dateString) {
      let date = new Date(dateString);
      var day = date.getDate() + "";
      var month = (date.getMonth() + 1) + "";
      var year = date.getFullYear() + "";
      var hour = (date.getHours() + 5) > 23 ? date.getHours() : date.getHours() + 5 + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);
      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    },

    formatDateMinus(dateString) {
      let date = new Date(dateString);
      var day = date.getDate() + "";
      var month = (date.getMonth() + 1) + "";
      var year = date.getFullYear() + "";
      var hour = (date.getHours() - 5) < 0 ? date.getHours() : (date.getHours() - 5 + "");
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    },
    dateStart(){
      let date = new Date();
      // Five days ago
      date.setTime(date.getTime() - (5 * 24 * 60 * 60 * 1000)); // Convert hours to milliseconds - 60 minutes to an hour, 60 seconds to a minute, 1000 milliseconds to a second

      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours()+"";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";


      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    dateEnd(){
      let date = new Date();
      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    checkZero(data) {
      if (data.toLocaleString().length == 1) {
        data = "0" + data;
      }
      return data;
    },

    reload() {
      let search = ""
      if( Capacitor.getPlatform() !== 'web' ) {
        search = localStorage.getItem('username');
      }
      if (this.$store.state.deviceUser == '' || this.$store.state.deviceUser == null) {
        search = this.$store.state.idUser
      } else {
        search = this.$store.state.deviceUser.login
      }
      //Busca si es admin
      if(this.$store.getters.isAdmin) {
        this.userList = []
        this.$store.dispatch('getUsersForAdmin').then(response => {
          let childrenToSplice = []
          for (const user of response.data) {

            user.completeName = user.firstName + " " + user.lastName
            user.clientData = JSON.parse(user.clientData)
            let item = { id: user.login, name: user.completeName, children: [], authority: user.authorities[0], gender:"Masculino", group: "test", open: true}

            if(user.clientData != null && user.clientData.genero != null){
              item.gender = user.clientData.genero
            }

            if(user.clientData != null && user.clientData.devices != null){
              user.children = user.clientData.devices
            }
            if(user.clientData != null && user.clientData.userChildren != null){
              for (const child of user.clientData.userChildren) {
                if(child != null){
                  try {
                    let itemChild = { id: child.login, name: child.firstName + " " + child.lastName, authority: "ROLE_USER", gender: child.clientData.genero, group: "test", open: true }
                    item.children.push(itemChild)
                    //childrenToSplice.push(itemChild)
                  } catch (e) {
                    //console.log(child.clientData)
                  }
                }
              }
            }

            this.userList.push(user)
            this.items.push(item)
          }
          // for(const child of childrenToSplice){
          //   let index = this.items.findIndex(item => item.id === child.id);
          //   this.items.splice(index, 1);
          // }
          this.itemsOriginal= this.items
          this.items.sort((a, b) => (a.name > b.name) ? 1 : -1)

        })
        //Busca flota/Chofer
      }else {
        this.userList = []
        this.$store.dispatch('getOneUser', search).then(response => {
          let user = response.data
          let childrenToSplice = []
          try{
            user.completeName = user.firstName + " " + user.lastName
            user.clientData = JSON.parse(user.clientData)
            let item = { id: user.login, name: user.completeName, children: [], authority: user.authorities[0], gender:"Masculino"}

            if(user.clientData != null && user.clientData.genero != null){
              item.gender = user.clientData.genero
            }

            if(user.clientData != null && user.clientData.devices != null){
              user.children = user.clientData.devices
            }
            if(user.clientData != null && user.clientData.userChildren != null){
              for (const child of user.clientData.userChildren) {
                if (child != null) {
                  try {
                    let itemChild = { id: child.login, name: child.firstName + " " + child.lastName, authority: "ROLE_USER", gender: child.clientData.genero, group: "test", open: true }
                    item.children.push(itemChild)
                    childrenToSplice.push(itemChild)
                  } catch (e) {
                    console.log("No hay datos hijo")
                  }
                }
              }
            }

            this.userList.push(user)
            this.items.push(item)
            this.items.sort((a, b) => (a.name > b.name) ? 1 : -1)
            this.$store.state.progress = false

          }catch (e){
            console.log("No hay datos de dispositivos")
          }
        });
      }
    },
    clearIntervalVue(reloadInterval) {
      clearInterval(this.$store.state.intervalMapDevice)
      clearInterval(this.$store.state.intervalMap)
      if(reloadInterval){
        this.createInterval()
      }
    },
  },
  computed: {
  },
  created() {
    this.reload();
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function (event)
    {
      history.pushState(null, document.title, location.href);
    });

    //Enable push notifications
    if(Capacitor.getPlatform() !== 'web') {
      // Request permission to use push notifications
      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        }
      });

      //Getting token device
      PushNotifications.addListener(
        'registration',
        (token) => {
          //Getting user
          this.$store.dispatch('getOneUser', this.$store.state.idUser).then(
            responseUser => {
              //WORKING
              //responseUser.data.pushTokenDevice = token.value;
              // this.$store.dispatch('updateUser', responseUser.data).then(
              //   response => console.info("User updated with pushTokenDevice.")
              // ).catch((error) => {
              //   console.error("Error updating user with pushTokenDevice.");
              //   console.error(error);
              // })
              let tokens = [];

              // Check if pushTokenDevice already exists and is a JSON string
              if (responseUser.data.pushTokenDevice && responseUser.data.pushTokenDevice !== null) {
                try {
                  tokens = JSON.parse(responseUser.data.pushTokenDevice);
                } catch (e) {
                  console.error("Error parsing existing pushTokenDevice value:", e);
                  // If parsing fails, initialize tokens as an empty array
                }
              }

              // Check if the token already exists in the tokens array
              if (!tokens.includes(token.value)) {
                // Add the new token to the tokens array if it doesn't exist
                tokens.push(token.value);

                // Convert the updated tokens array to a JSON string
                responseUser.data.pushTokenDevice = JSON.stringify(tokens);

                // Dispatch the updateUser action
                this.$store.dispatch('updateUser', responseUser.data).then(
                  response => console.info("User updated with pushTokenDevice.")
                ).catch((error) => {
                  console.error("Error updating user with pushTokenDevice.");
                  console.error(error);
                });
              } else {
                console.info("Token already exists, not updating user.");
              }
             
          }).catch((error) => {
            console.error("Error getting user.");
            console.error(error);
          });
        });

      PushNotifications.addListener(
        'registrationError',
        (err) => {
          console.info('Registration error: ', err.error);
        }
      );

      // Show us the notification payload if the app is open on our device
      PushNotifications.addListener('pushNotificationReceived', async (notification) => {
        console.info('Push received: ', JSON.stringify(notification));

        // Show the notification as a local notification
        await LocalNotifications.schedule({
          notifications: [
            {
              title: notification.title,
              body: notification.body,
              id: new Date().getTime(),
              schedule: { at: new Date(Date.now() + 1000) }, // Show immediately
              sound: null,
              attachments: null,
              actionTypeId: "",
              extra: null
            }
          ]
        });

        // Show the notification in the app UI
        // this.device.notificationBody = notification.body;
        // this.device.notificationDataDeviceName = notification.data.deviceName;
        // this.dialogNotification = true;
      });

      // Method called when tapping on a notification
      PushNotifications.addListener(
        'pushNotificationActionPerformed',
        (notification) => {
        console.info('Push action performed', JSON.stringify(notification));
      }
    );

    }

  }

};
</script>

<style scoped>
.container {
  max-width: 100% !important;
  padding: 0%;
}

.styleDeviceStatus {
  margin-left: 12%;
  width: 120px;
  height: 120px;
  float: left;
  background-color: white;
  border-radius: 10%;
}

.styleDeviceStatus2 {
  margin-top: -15px;
  margin-left: 12%;
  width: 120px;
  height: 150px;
  float: left;
  background-color: white;
  border-radius: 10%;
}

.styleDeviceName {
  text-align: center;
  width: 80%;
  height: 30px;
  background-color: white;
}

.styleDeviceSpeed {
  font-weight: bold;
  font-size: 35px;
  padding-top: 0
}

.circleButton {
  height: 80px;
  width: 80px;
  background-color: white;
}

.circleButton a {
  color: inherit;
}
.disable-events {
  pointer-events: none
}

.enable-events {
  pointer-events: none !important;
}

.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  top: 100px;
  left: 0;
  overflow-y: hidden;
  overflow-x: hidden;
 }

 .selected-item {
  background-color: lightgray;
  width: 100%;
}

.flex-container {
  display: flex;
  align-items: center;
}
.text-tree-view {
  margin-top: 10px;
  padding-block: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/device/mobile/DeviceMobile.vue